//Auth types

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const CHANGE_STATE = "CHANGE_STATE";
export const CHECK_CLASSES = "CHECK_CLASSES";
export const CHECK_STAFF_TYPE = "CHECK_STAFF_TYPE";
export const CHANGE_STATE_MULTI = "CHANGE_STATE_MULTI"
